import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Link, Typography } from '@mui/material'

export const SubscribeToView = () => {
  const navigate = useNavigate()
  const SubscribeClick = e => {
    e && e.preventDefault()
    navigate('/welcome')
  }
  return (
    <Link onClick={SubscribeClick} underline="hover" sx={{ cursor: 'pointer' }}>
      <Typography component="span" variant="body2B" color="secondary">
        Upgrade to view
      </Typography>
    </Link>
  )
}

export default SubscribeToView
